var collectionSliders = document.querySelectorAll('.js-collection-slider');

if (collectionSliders.length > 0) {
    collectionSliders.forEach(uneSlider => {
        if (uneSlider.classList.contains('splide')) {


            var splideInstance = null;

            function initSlider() {
                var gap = 36;

                if (isDeviceMobile) {
                    gap = 20;
                }

                if (splideInstance) {
                    splideInstance.destroy(true);
                    splideInstance = null;
                }

                splideInstance = new Splide(uneSlider, {
                    autoWidth: true,
                    perMove: 1,
                    gap: `${gap / 16}rem`,
                    snap: true,
                    pagination: false,
                    drag: true,
                });

                splideInstance.on('overflow', function (isOverflow) {

                    splideInstance.go(0);

                    splideInstance.options = {
                        arrows: isOverflow,
                        drag: isOverflow,
                    };
                });


                splideInstance.mount();

            }

            // Init au chargement
            initSlider();

            // Reinit au resize (avec debounce)
            var resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    initSlider();
                }, 200);
            });

        }
    })
}
